
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommExchangeBOMGrid extends Serenity.EntityGrid<ECommExchangeBOMRow, any> {
        protected getColumnsKey() { return 'ECommerce.ECommExchangeBOM'; }
        protected getDialogType() { return ECommExchangeBOMDialog; }
        protected getIdProperty() { return ECommExchangeBOMRow.idProperty; }
        protected getInsertPermission() { return ECommExchangeBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommExchangeBOMRow.localTextPrefix; }
        protected getService() { return ECommExchangeBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}